import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export enum Decision {
  None = 'none',
  Stay = 'stay',
  Leave = 'leave',
}

@Component({
  selector: 'app-stay-or-leave-study-area-modal',
  templateUrl: './stay-or-leave-study-area-modal.component.html',
})
export class StayOrLeaveStudyAreaModalComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}
  Decision = Decision;

  onCancel() {
    this.ref.close();
  }

  onAccept(decision?: Decision) {
    this.ref.close(decision);
  }
}
